import { Routes } from '@angular/router';
import { AccountVerifyComponent } from './admin/login/account-verify/account-verify.component';
import { LoginComponent } from './admin/login/login.component';
import { RegistrationComponent } from './admin/login/registration/registration.component';
import { HomeComponent } from './user/home/home.component';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'registration', component: RegistrationComponent },
  { path: 'accountverify', component: AccountVerifyComponent },
  {
    path: '',
    loadChildren: () => import('./user/user.routes').then((m) => m.USER_ROUTES),
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.routes').then((m) => m.ADMIN_ROUTES),
  },
  { path: '**', component: HomeComponent },
];
